import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { CreateIdeaMassModal } from '../../createIdeaMass'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    if (ReactDOM?.render) {
      ReactDOM?.render(<CreateInspiration {...props} visible container={div} />, div)
    } else if (ReactDOMClient.createRoot) {
      const root = ReactDOMClient.createRoot(div)
      root.render(<CreateInspiration {...props} visible container={div} />)
    }
  })
}

const CreateInspiration = (props) => {
  const { visible, onChange, onChooseTaskOk, onCancel, onOk, onChooseTaskClose, parentId, disabledTask, trackSource } = props
  const [_visible, set_Visible] = useState(visible)
  const [users, setUsers] = useState([])

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }

  return <CreateIdeaMassModal
    disabledTask={disabledTask}
    visible={_visible}
    setVisible={set_Visible}
    onChooseTaskOk={onChooseTaskOk}
    onChooseTaskClose={onChooseTaskClose}
    onChange={onChange}
    parentId={parentId}
    setUsers={setUsers}
    users={users}
    onCancel={_cancel}
    onOk={onOk}
    trackSource={trackSource}
  />
}
